/** Matchups show whenever a schedule exists, independent of league status. */
export const shouldShowMatchups = (matchupCount: number): boolean => matchupCount > 0;

/** Standings/transactions/recent-activity gate. Playoffs included. */
export const shouldShowStandings = (status: string | undefined | null): boolean =>
  status === 'active' || status === 'playoffs' || status === 'completed';
